import { ProductData } from "data/product/products"


export const sortProductsByIndex = (productA: ProductData, productB: ProductData) => {
    if (productA.orderIndex < productB.orderIndex){
        return -1
    }
    return 1
}